import React from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter, Link } from "react-router-dom";
import { toggleSidebar } from "../../redux/SidebarAction";

class Sidebar extends React.Component {

  toggleSidebar = () => {
    this.props.toggleSidebar();
  };

  render() {
    const { t, location, appState } = this.props;
    const isOpen = appState.sidebarOpen;
    
    const menuItems = [
      { public: true, path: "/", icon: require("../../assets/img/desktop/menus/home.png"), label: t("HOME") },
      { public: true, path: "/slots", icon: require("../../assets/img/desktop/menus/slot.png"), label: t("SLOTS") },
      { public: true, path: "/casino", icon: require("../../assets/img/desktop/menus/casino.png"), label: t("CASINO") },
      { public: true, path: "/fish-hunt", icon: require("../../assets/img/desktop/menus/fishhunt.png"), label: t("Fish Hunt") },
      { public: true, path: "/lottery", icon: require("../../assets/img/desktop/menus/lottery.png"), label: t("LOTTERY") },
      { public: true, path: "/sports", icon: require("../../assets/img/desktop/menus/sports.png"), label: t("Sports") },
      { public: true, path: "/fs-promotion", icon: require("../../assets/img/desktop/menus/promotion.png"), label: t("PROMOTION") },
      { public: true, path: "/vip-benefits", icon: require("../../assets/img/desktop/menus/vip.png"), label: t("VIP_PROGRAM") },
      { public: true, path: "/commissions-info", icon: require("../../assets/img/desktop/menus/commission.png"), label: t("COMMISSION") },
      { public: false, path: "/referral-groups", icon: require("../../assets/img/desktop/menus/qrcode.png"), label: t("REFERRAL") },
      { public: true, path: "/livechat", icon: require("../../assets/img/desktop/menus/chat.png"), label: t("LIVE_CHAT") }
    ];

    const handleScrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // optional: for smooth scrolling
      });
    };

    return (
      <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <button className="sidebar-toggle" onClick={this.toggleSidebar}>
            <i className="fas fa-bars"></i>
          </button>
        </div>
        
        <nav className="sidebar-nav">
          <ul className="nav-list">
            {menuItems.map((item, index) => {
              const isActive = location.pathname === item.path;
              const canShow = item.public || (!item.public && this.props.authState?.isLoggedIn);

              if(canShow)
              return (
                <li key={index} className={`nav-item ${isActive ? 'active' : ''}`}>
                  <Link 
                    to={item.path} className="nav-link"
                    onClick={() => handleScrollToTop()}
                  >
                    <div className="nav-icon">
                      <img
                        src={item.icon}
                        className="img-responsive"
                        alt={item.label}
                        loading="lazy"
                      />
                    </div>
                    <span className="nav-label">{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  appState: state.appState,
});

const mapDispatchToProps = {
  toggleSidebar
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouter(Sidebar)));
